<template>
    <div>
        <v-alert 
            text
            dense
            color="warning"          
            icon="mdi-alert-outline"    
        >
            <span class="black--text mr-2"> Deixe os dados do visitante em branco caso deseje preencher manualmente </span>
        </v-alert>

        <v-form ref="form">
            <v-row dense>
                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <v-text-field
                        v-model="item.nome"
                        outlined
                        dense
                        :class="$css_field"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Nome visitante (opcional)</span>
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                    <v-text-field
                        v-model="item.cpf"
                        v-mask="['###.###.###-##']"
                        outlined
                        dense
                        :class="$css_field"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">CPF (opcional)</span>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                    <v-text-field
                        v-model="item.telefone"
                        v-mask="['(##) ####-####', '(##) #####-####']"
                        outlined
                        dense
                        :class="$css_field"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Telefone (opcional)</span>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <v-text-field
                        v-model="item.email"
                        outlined
                        dense
                        :class="$css_field"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">E-mail (opcional)</span>
                        </template>
                    </v-text-field>
                </v-col> 
            </v-row>
            <v-row dense>
                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="text-center">
                    <v-btn
                        color="secondary"
                        @click.prevent="clear" 
                        :class="$css_button + ' mr-8'"
                    >
                        Limpar
                    </v-btn>
                    
                    <v-btn
                        dark
                        color="primary"
                        :class="$css_button"
                        @click.prevent="property_viewing_form()"
                    >
                        Baixar ficha PDF
                    </v-btn> 
                </v-col>
            </v-row>           
            
        </v-form>
    </div>
</template>

<script>
export default {
    props: {
        multiple_codigo: {
            require: true,
        }
    },

    watch: {
        multiple_codigo: {
            handler() {
                this.item.nome = null,
                this.item.cpf = null,
                this.item.telefone = null
                this.clear()
            },
            immediate: true // ← garante que execute mesmo se já estiver definido
        }
    },

    data () {
        return {
            item: {
                nome: null,
                cpf: null,
                telefone: null
            }
        }
    },
    
    methods: {
        clear() {
            this.$refs.form.reset()
        },

        property_viewing_form(){
            const params = {}
            params.multiple_codigo = this.multiple_codigo;
            params.nome = this.item.nome;
            params.cpf = this.item.cpf;
            params.telefone = this.item.telefone;
            params.file_name = 'ficha-visita.pdf';
 
            this.$store.dispatch('property_viewing_form', params) 
                        .then(response => {
                           this.$snotify.success('Download em andamento');
                        })
            
        }
        
    }
}
</script>